<script>
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import TopicTile from '../TopicTile/TopicTile.svelte';

  let { headingText, headingLevel = 'h2', topicTiles, dataTestId = 'popular-topics-list' } = $props();
</script>

<div class="bg-gray-mercury" class:mt-8={headingText}>
  <div data-testid={dataTestId} class="w-full pt-8 pb-10 lg:pt-10 lg:pb-12 mx-auto max-w-6xl">
    {#if headingText}
      <BaseHeading {headingLevel} className="px-4 text-lg md:text-1.5xl lg:text-3xl text-blue-dark-navy mb-4 xl:mb-8">
        {headingText}
      </BaseHeading>
    {/if}
    <div class="px-4 grid gap-4 md:grid-cols-2 lg:gap-6 lg:grid-cols-3 xl:gap-10">
      {#each topicTiles as topicTile, index (index)}
        <TopicTile {...topicTile} />
      {/each}
    </div>
  </div>
</div>
